import { TagFilterModel } from "@models/filter";
import React from "react";
export interface TagFilterProps {
  filterHeader?: string;
  tags: TagFilterModel[];
  isAllSelected: boolean;
  selectedFilters: string[];
  handleFilterClick: (val: string) => void;
  handleAllSelection: () => void;
}
const TagFilter: React.FunctionComponent<TagFilterProps> = ({
  tags,
  filterHeader = "Filters",
  isAllSelected,
  selectedFilters,
  handleFilterClick,
  handleAllSelection,
}) => {
  return (
    <div className="shrink-0">
      <span className="text-lg font-semibold text-dark-purple-50 px-4 lg:px-0">
        {filterHeader}
      </span>
      <div key={"filter-all"} className="mt-4 mb-3 px-4 lg:px-0">
        <input
          id="all"
          type="checkbox"
          value={"all"}
          checked={isAllSelected}
          onChange={handleAllSelection}
        />
        <label className="ml-3" htmlFor="all">
          {"All"}
        </label>
      </div>
      <div className="flex flex-wrap max-w-[700px] lg:block px-4 lg:px-0">
        {tags.map((oneTag) => {
          const { id, title, slug } = oneTag?.node ?? {};
          return (
            <div key={id} className="mb-3 mr-5">
              <input
                id={id}
                type="checkbox"
                value={slug}
                checked={selectedFilters?.includes(slug)}
                onChange={(e) => {
                  handleFilterClick(e.target.value);
                }}
              />
              <label className="ml-1 lg:ml-3" htmlFor={id}>
                {title}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TagFilter;
